import React, { useRef } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { X } from "lucide-react";
import { FaUser, FaPhone, FaMapMarkerAlt, FaBuilding, FaDownload, FaCode } from "react-icons/fa";

function ViewOrderQRCode({ order, closeModal }) {
  const qrCodeRef = useRef(null);
  if (!order) return null;

  const vendor = order.products[0]?.vendorId || {};

  const qrURL = `${window.location.origin}/vendor-manager/order-details/${order._id}`;

  const downloadQRCode = () => {
    const canvas = qrCodeRef.current.querySelector("canvas");
    const url = canvas.toDataURL("image/png");
    const link = document.createElement("a");
    link.href = url;
    link.download = `order-${order.orderId}-qr.png`;
    link.click();
  };

  console.log(order);



  return (
    <div className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center px-4">
      <div className="bg-white w-full max-w-sm md:max-w-md rounded-2xl relative shadow-2xl overflow-hidden">

        {/* CLOSE BUTTON */}
        <button
          onClick={closeModal}
          className="absolute top-3 right-3 bg-gray-100 hover:bg-gray-200 rounded-full p-2 transition"
        >
          <X size={18} />
        </button>

        {/* QR SECTION */}
        <div className="text-center px-6 pt-8 pb-4">
          <div
            ref={qrCodeRef}
            className="mx-auto w-fit border-2 border-dashed border-gray-300 p-4 rounded-2xl bg-white shadow-sm"
          >
            <QRCodeCanvas value={qrURL} size={200} level="H" />
          </div>

          <h2 className="mt-4 text-lg font-semibold text-gray-800">
            Token No :{" "}
            <span className="text-orange-600">
              {order?.tokenNo || "N/A"}
            </span>
          </h2>

          <p className="text-xs text-gray-500 mt-1">
            Order ID : {order.orderId}
          </p>
        </div>

        {/* VENDOR DETAILS */}
        <div className="mx-4 mb-3 bg-gray-50 rounded-xl border p-4 space-y-2 text-sm">
          <h3 className="font-semibold text-gray-800 border-b pb-1 mb-2">
            Vendor Details
          </h3>

          <p className="flex items-center gap-2">
            <FaUser className="text-blue-600" />
            <span className="capitalize">{order?.vendorManagerId?.name || "N/A"}</span>
          </p>

          {vendor.companyName && (
            <p className="flex items-center gap-2">
              <FaBuilding className="text-purple-600" />
              <span>{vendor.companyName}</span>
            </p>
          )}


          {
            order?.vendorManagerId?.corporateCodeId && order?.vendorManagerId?.corporateCodeId.length > 0 && (
              <p className="flex items-center gap-2">
                <FaCode className="text-green-600" />
                <span>{order?.vendorManagerId?.corporateCodeId[0]?.corporateCode || "N/A"}</span>
              </p>
            )
          }


          {vendor.address && (
            <p className="flex items-start gap-2 leading-snug">
              <FaMapMarkerAlt className="text-red-600 mt-0.5" />
              <span>{vendor.address}</span>
            </p>
          )}
        </div>

        {/* INFO TEXT */}
        <p className="text-center text-xs text-gray-500 px-6">
          Please scan the QR at counter.
          We’ll notify you once your order is ready.
        </p>

        {/* ACTION BUTTONS */}
        <div className="flex gap-3 px-6 py-5">
          <button
            onClick={downloadQRCode}
            className="flex-1 bg-orange-500 text-white font-semibold py-3 rounded-xl flex justify-center items-center gap-2 hover:bg-orange-600 transition"
          >
            <FaDownload />
            Download QR
          </button>

          <button
            onClick={closeModal}
            className="flex-1 bg-gray-200 text-gray-700 font-semibold py-3 rounded-xl hover:bg-gray-300 transition"
          >
            Close
          </button>
        </div>
      </div>
    </div>

  );
}

export default ViewOrderQRCode;
